module.exports = __webpack_public_path__ + "static/media/S3N7-2.4617e129.svg";